import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Question } from '../question';

@Component({
  selector: 'lms-question-create',
  templateUrl: './question-create.component.html',
  styleUrls: ['./question-create.component.scss']
})
export class QuestionCreateComponent implements OnInit, OnDestroy {
  public paramsSubscription: any;
  public documentId: any;
  public clientId: string;

  constructor(public location: Location, public route: ActivatedRoute, public router: Router) {}

  ngOnInit(): void {
    this.paramsSubscription = this.route.queryParamMap.subscribe((queryParams: ParamMap) => {
      this.documentId = queryParams.get('documentId');
      this.clientId = queryParams.get('clientId');
    });
  }

  ngOnDestroy(): void {
    this.paramsSubscription.unsubscribe();
  }

  onSave(question: Question): void {
    this.router.navigate(['/documents', this.documentId], { replaceUrl: true });
  }

  cancel(): void {
    this.location.back();
  }
}
